import React, { useState } from "react";
import { ImageSelector } from "./ImageSelector.jsx";
import { MessagePopup } from "components/shared/Popups.jsx";
import { MdDelete } from "react-icons/md";

export const ThumbnailPicker = ({ location, onSubmit }) => {
  const [selectedImages, setSelectedImages] = useState(location?.thumbnailImages || []); // Existing images from DB
  const [newImages, setNewImages] = useState([]); // New images to be added
  const [popup, setPopup] = useState({ show: false, message: "", type: "" });


  // ✅ Handle Image Selection from `ImageSelector`
  const handleImageSelection = (image, index) => {
    const updatedImages = [...newImages];
    updatedImages[index] = image;
    setNewImages(updatedImages);
  };

  // ✅ Add More Image Selector Fields
  const handleAddMoreImages = () => {
    setNewImages([...newImages, null]); // Adds a new empty field
  };

  // ✅ Handle Deleting an Existing Image (Database Image)
  const handleDeleteExistingImage = (index) => {
    const updatedImages = selectedImages.filter((_, i) => i !== index);
    setSelectedImages(updatedImages);
  };

  // ✅ Handle Deleting a Newly Added Image
  const handleDeleteNewImage = (index) => {
    const updatedImages = newImages.filter((_, i) => i !== index);
    setNewImages(updatedImages);
  };

  // ✅ Handle Form Submission (Send images in `thumbnailImages`)
  const handleSubmit = (e) => {
    e.preventDefault();
    setPopup({ show: true, message: "Submitting...", type: "loading" });
    const updatedThumbnailImages = [...selectedImages, ...newImages.filter((img) => img !== null)];

    // ✅ Send the final `thumbnailImages` array
    onSubmit({ thumbnailImages: updatedThumbnailImages })
      .then(() => {
        setPopup({ show: true, message: "✅ Form submitted successfully!", type: "success" });
        setTimeout(() => setPopup({ show: false, message: "", type: "" }), 3000);
      })
      .catch(() => {
        setPopup({ show: true, message: "❌ Failed to submit the form. Please try again.", type: "error" });
        setTimeout(() => setPopup({ show: false, message: "", type: "" }), 3000);
      });
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: "100%", margin: "auto", padding: "30px" }}>
      <h3>Upload Thumbnail Image </h3>
      {popup.show && (
        <MessagePopup
          message={popup.message}
          type={popup.type}
          onClose={() => setPopup({ show: false, message: "", type: "" })}
        />
      )}
      {/* ✅ Display Existing Images from Database */}
      {selectedImages.length > 0 && (
        <div style={styles.gridContainer}>
          {selectedImages.map((image, index) => (
            <div key={index} style={styles.imageWrapper}>
              <img src={image.compressedFilePath} alt={`Thumbnail ${index}`} style={styles.thumbnail} />
              <p style={styles.imageName}>{image.title}</p>
              <button onClick={() => handleDeleteExistingImage(index)} style={styles.deleteButton}>
                <MdDelete />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* ✅ Image Upload Inputs Using ImageSelector */}
      <div style={styles.gridContainer}>
        {newImages.map((_, index) => (
          <div key={index} style={styles.imageWrapper}>
            <ImageSelector
              selectedImage={newImages[index]}
              handleImageSelection={(image) => handleImageSelection(image, index)}
            />
            {newImages[index] && (
              <button onClick={() => handleDeleteNewImage(index)} style={styles.deleteButton}>
                ❌ Remove
              </button>
            )}
          </div>
        ))}
      </div>

      {/* ✅ Buttons */}
      <div style={{ display: "flex", justifyContent: "start", gap: "10px", marginTop: "20px" }}>
        <button type="button" onClick={handleAddMoreImages} style={styles.addButton}>
          ➕ Add More Images
        </button>
        <button type="submit" style={styles.submitButton}>
          ✅ Submit Now
        </button>
      </div>
    </form>
  );
};

// 🔥 Styles for Responsive 3-Column Grid Layout
const styles = {
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: "15px",
    marginTop: "20px",
  },
  imageWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    background: "#f9f9f9",
    position: "relative",
  },
  thumbnail: {
    width: "100%",
    height: "auto",
    aspectRatio: '4/3',
    objectFit: "cover",
    borderRadius: "5px",
  },
  imageName: {
    marginTop: "5px",
    fontSize: "16px",
    textAlign: "center",
    color: "#555",
  },
  addButton: {
    padding: "10px 15px",
    background: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  submitButton: {
    padding: "10px 15px",
    background: "#28a745",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  deleteButton: {
    marginTop: "5px",
    padding: "5px 10px",
    background: "#dc3545",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default ThumbnailPicker;
